import { TreeRange, toDomRange } from "../writeshift/Range";

function getPhraseFromTextarea(
  treeRange: TreeRange,
  root: HTMLTextAreaElement
): string | null {
  // All these should be in the root (because text nodes in a textarea can't be accessed,
  // only the text can be accessed through .value)
  console.assert(treeRange.start.index.length === 0);
  console.assert(treeRange.end.index.length === 0);

  const text = root.value;
  return text.slice(treeRange.start.offset, treeRange.end.offset);
}

export function getPhrase(treeRange: TreeRange, root: Element): string | null {
  if (root instanceof HTMLTextAreaElement) {
    // we gotta do something special here
    return getPhraseFromTextarea(treeRange, root);
  }
  let range: Range | null = null;

  try {
    range = toDomRange(root, treeRange);
  } catch (error) {
    if (error instanceof DOMException) {
      // This is an out of bounds exception... the alert might out of sync
      // with the dom, which means that the range.setStart might throw
      // This isn't a big deal because the alert should eventually sync up
      console.debug(error);
    } else if (error instanceof TypeError) {
      // Might be the same as the above, but I'm not sure why it's happening
      console.warn(error);
    } else {
      throw error;
    }
  }
  return range ? range.toString() : null;
}
